export default __webpack_public_path__ + "static/media/disk.d1e123aa.gif";